import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      display: 'flex',
      height: '80px',
    },
    controlAndStatus: {
      display: 'flex',
      flexDirection: 'column',
      width: '450px',
      marginRight: '30px',
    },
    status: {
      paddingBottom: '10px',
      paddingLeft: '8px',
      fontSize: '13px',
      width: '450px',
    },
    inputWithButton: {
      display: 'flex',
    },
    versionsTable: {
      width: '100%',
      marginTop: '-18px',
    },
    button: {
      marginLeft: '8px',
    },
  },
  {
    name: 'CanaryManagement',
  },
);
